// スライダー
$('.slick-slider').slick({
  autoplay: true,
  infinite: true,
  slidesToScroll: 1,
  autoplaySpeed:3000,
  centerMode: true,
  centerPadding: "35%",
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 769,//モニターの横幅が769px以下の見せ方
      settings: {
        centerPadding: "15%"
      }
    },{
      breakpoint: 550,//モニターの横幅が769px以下の見せ方
      settings: {
        centerPadding: "5%"
      }
    }
  ]
});